import { PlusCircleIcon } from '@fourthwall/icons'
import React, { type ComponentProps } from 'react'
import { TextButton } from '../TextButton/TextButton'

type Props = ComponentProps<typeof TextButton>

export const AddButton = (props: Props) => {
  return (
    <TextButton
      icon={PlusCircleIcon}
      size="large"
      variant="secondary"
      testid="AddButton"
      {...props}
    />
  )
}
